import {
  ColorCodes
} from '@vodacom/web-common';

const Colors = {
  Green5: '#428600',
  Grey11: '#282828',
  Grey12: '#EFEFF5',
  Grey13: '#E0E0E0',
  Grey14: '#676767',
  Grey15: '#F1F1F1',
  Grey16: '#4A4D4E',
  Grey17: '#979797',
  Grey18: '#4A4A4A',
  Grey19: '#EFEFEF',
  Grey20: '#C4C4C4',
  Grey21: '#CCCCCC',
  Black5: '#333333',
  Blue5: '#00ACED',
  Blue6: '#015fbf',
  Blue7: '#005765',
  Red5: '#990000',
  TransparentBlack1: 'rgba(0, 0, 0, 0.15)',
  TransparentBlack2: 'rgba(0, 0, 0, 0.8)',
  TransparentBlack3: 'rgba(51, 51, 51, 0.6)',
  TransparentBlack4: 'rgba(8, 8, 27, 1)',
  Yellow3: '#FECB00',
  GradientRed: 'linear-gradient(127.99deg, #AC0101 19.39%, #AC0101 19.39%, #E60000 90.76%)',
  GradientBlue: 'linear-gradient(48.1deg, #2D4475 12.43%, #8AABEF 95.47%)',
  GradientBlue2: 'linear-gradient(46.78deg, #2D4475 12.71%, #8AABEF 97.64%)   ',
  GradientWhite: 'linear-gradient(0deg, #CCCCCC, #CCCCCC)'
};

export const CustomColors = { ...ColorCodes, ...Colors };
